import { render, staticRenderFns } from "./MedSurvey.vue?vue&type=template&id=2584d525&scoped=true&"
import script from "./MedSurvey.vue?vue&type=script&lang=js&"
export * from "./MedSurvey.vue?vue&type=script&lang=js&"
import style0 from "./MedSurvey.vue?vue&type=style&index=0&id=2584d525&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2584d525",
  null
  
)

export default component.exports